import React, { useState, useEffect } from "react";
import AdminLayout from '../../layout/AdminLayout';
import Classes from '../../asset/styles/AdminCreatedLaunchpadList.module.css';
import { subscribeData } from "../../actions/cmsActions"; // Assuming this is a helper for API calls

const SubscribePage = () => {
    const [subscribeValue, setSubscribeValue] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const list = async () => {
        try {
            const payload = {
                currentPage, itemsPerPage
            }
            const getList = await subscribeData(payload);
            if (getList.data) {
                setSubscribeValue(getList.data.list);
                setTotalItems(getList.data.totalRecords);
                setTotalPages(getList.data.totalPages);
            } else {
                setSubscribeValue([]);
                setTotalItems(0);
                setTotalPages(0);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        list();
    }, [currentPage]);

    return (
        <>
            <AdminLayout>
                <div className={`${Classes.adminChangeCont} p-2 p-sm-3 p-md-4 p-lg-5`}>
                    <h2 className={`${Classes.launchpad__title} text-uppercase aboro_font`}>
                        Subscriber Details
                    </h2>
                    <div className={`${Classes.cmnTableHolder}`}>
                        <table className={`${Classes.tokenCmnTable} mt-5`}>
                            <thead>
                                <tr>
                                    <th className="px-3 py-2">S.No</th>
                                    <th className="px-3 py-2">Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subscribeValue && subscribeValue.length > 0 ? (
                                    subscribeValue.map((item, index) => (
                                        <tr className={`${Classes.gradientBorder}`} key={item._id}>

                                            <td className="px-3 py-1">
                                                <p className={`${Classes.tableTokenName} poppins m-0 position-relative py-3`}>
                                                    {item.serialNumber}
                                                </p>
                                            </td>

                                            <td className="px-3 py-1">
                                                <p className={`${Classes.tableTokenName} poppins m-0 position-relative py-3`}>
                                                    {item.email}
                                                </p>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="text-center b_wdth poppins pt-5">
                                            Here No Subscriber Details
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {/* <div className="pagination-container">
                        <nav>
                            <ul className="pagination">
                                {currentPage > 1 && (
                                    <li className="page-item">
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            Prev
                                        </button>
                                    </li>
                                )}

                                {[...Array(totalPages)].map((_, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}

                                {currentPage < totalPages && (
                                    <li className="page-item">
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div> */}
                </div>
            </AdminLayout>
        </>
    );
};

export default SubscribePage;
